import { render, staticRenderFns } from "./RemoveStaffGroupError.vue?vue&type=template&id=6832e64a&scoped=true&"
import script from "./RemoveStaffGroupError.vue?vue&type=script&lang=js&"
export * from "./RemoveStaffGroupError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6832e64a",
  null
  
)

export default component.exports